import { useState } from 'react';
import type { Comic } from '@/mocks/manga';
import { categories, comics } from '@/mocks/manga';

interface Props {
  filter: string;
  onChangeFilter: (key: string) => void;
  onOpen: (comic: Comic) => void;
}

export default function HotComics({ filter, onChangeFilter, onOpen }: Props) {
  const [active, setActive] = useState(filter);

  const handleFilter = (key: string) => {
    setActive(key);
    onChangeFilter(key);
  };

  const list = active === '全部' ? comics : comics.filter((c) => c.category === active);

  return (
    <section id="hot" className="scroll-mt-20 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-fire-fill" />
              热门推荐
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              当下人气最高的女神系作品
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600">
              依据读者人气与编辑口味挑选的推荐列表，点击分类可筛选，点击封面可查看作品详情。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {['全部', ...categories.map((c) => c.key)].map((k) => {
            const label = k === '全部' ? '全部' : categories.find((c) => c.key === k)?.name ?? k;
            const isActive = active === k;
            return (
              <button
                key={k}
                type="button"
                onClick={() => handleFilter(k)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {list.map((comic) => (
            <button
              key={comic.id}
              type="button"
              onClick={() => onOpen(comic)}
              className="group cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-50 text-left transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 女神系漫画封面`}
                  className="aspect-[3/4] w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                  <i className="ri-star-fill text-accent-500" />
                  {comic.rating}
                </span>
                <span
                  className={`absolute right-3 top-3 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
                    comic.status === '连载中' ? 'bg-secondary-500' : 'bg-foreground-600'
                  }`}
                >
                  {comic.status}
                </span>
                <div className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center bg-primary-500/90 py-2.5 text-sm font-medium text-background-50 transition-transform duration-300 group-hover:translate-y-0">
                  查看详情
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900">{comic.title}</h3>
                <p className="mt-1 text-xs text-foreground-500">{comic.genre}</p>
                <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
                  <span>{comic.chapters}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-arrow-right-line" />
                    阅读
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}